(ns common.schema.entities.survey.survey-text-variables)

(def survey-template-variable-source
  :variable.source/survey-template-text)

(def variables
  [{:id "target"
    :label "Target"}
   {:id "reference_date"
    :label "Reference date"}
   {:id "reference_period"
    :label "Reference period"}
   {:id "invitee_email"
    :label "Invitee email"}
   {:id "other_invitees_emails"
    :label "Other invitees emails"}])

(def variable-ids
  (mapv :id variables))

(defn variable-ids-for-source
  [variable-source]
  (case variable-source
    :variable.source/survey-template-text variable-ids
    []))
